package com.neurobs.ccabserver.transcriptreview.components.transcriptselection.components

import com.neurobs.react.semanticui.UiDropdownFactory
import com.neurobs.ccabserver.transcriptreview.states.{AudioContextContext, ErrorState, ReviewSelectionState, TestTranscriptSelection, TranscriptSelectionState}
import com.neurobs.js.ccab.ServerContext
import com.neurobs.react.{ListBox, ListBoxItem, StyleUtil}
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.web.html._
import slinky.core.facade.ReactElement

import scala.collection.mutable.ArrayBuffer

@react
object TestTranscriptSelector {

	case class Props()

	val component = FunctionalComponent[Props] { _ =>

		val transcriptSelectionState = TranscriptSelectionState.accessState
		val reviewSelectionState = ReviewSelectionState.accessState()
		implicit val errorState = ErrorState.accessState
		implicit val ccabServer = ServerContext.accessState()
		implicit val audioContext = AudioContextContext.accessState()

		def testTranscriptItemGenerator(selection: TestTranscriptSelection): List[ReactElement] = {
			val subs = ArrayBuffer[ReactElement](
				UiDropdownFactory.DropdownSubtext(text = s"Test: ${selection.transcript.testName}"),
				br(),
				UiDropdownFactory.DropdownSubtext(text = s"Session id: ${selection.transcript.subjectId.toString}"),
				br(),
				UiDropdownFactory.DropdownSubtext(text = s"Reporting id: ${selection.transcript.reportingId}")
			)
			if (selection.reviewed.nonEmpty) {
				val reviewUsers = selection.reviewed.map(_.username).mkString(", ")
				subs.append(br(), UiDropdownFactory.DropdownSubtext(text = s"Reviewed by: $reviewUsers", styleAttributes = Seq(("color", "green"))))
			}
			List(
				div(className := "item")(
					subs: _*
				)
			)
		}

		val reviewButton = button(
			onClick := { () => transcriptSelectionState.data.value.testTranscript.foreach(reviewSelectionState.setSelection) },
			style := StyleUtil.makeStyle(("marginTop", "5px"), ("padding", "5px"))
		)("Review")

		val choices = transcriptSelectionState.filteredTestTranscriptSelections().getOrElse(Seq())
		case class TranscriptItem(item: TestTranscriptSelection) extends ListBoxItem {
			def content(): Seq[ReactElement] = testTranscriptItemGenerator(item)
			def equal(rhs: ListBoxItem): Boolean = item == rhs.asInstanceOf[TranscriptItem].item
			def select(): Unit = transcriptSelectionState.selectTestTranscript(item)
			def key(): String = item.transcript.testRunId.toString
		}
		div(

			ListBox(
				options = choices.map(TranscriptItem(_)),
				selection = transcriptSelectionState.data.value.testTranscript.map(TranscriptItem(_))
			),
			if (transcriptSelectionState.data.value.testTranscript.isDefined) reviewButton else null
		)
	}
}
